import { render, staticRenderFns } from "./PolygonImportDialog.vue?vue&type=template&id=22927441&"
import script from "./PolygonImportDialog.vue?vue&type=script&lang=js&"
export * from "./PolygonImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports